export class AzureDiskTarget {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroupName",
            "baseName": "resourceGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "settings",
            "baseName": "settings",
            "type": "AzureDiskSettings",
            "format": ""
        },
        {
            "name": "adeEncryption",
            "baseName": "adeEncryption",
            "type": "AdeRestoreEncryptionConfig",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureDiskTarget.attributeTypeMap;
    }
    constructor() {
    }
}
